export const isTwoRouteService = (service) => {
  if (service.tipoServico === null || service.tipoServico === undefined) {
    throw new Error('Tipo serviço null ou undefined');
  }

  return service.tipoServico === `REBOQUE` || service.tipoServico === 'SUBSOLO';
};

export const isThreeRouteService = (service) => {
  if (service.tipoServico === null || service.tipoServico === undefined) {
    throw new Error('Tipo serviço null ou undefined');
  }

  return service.tipoServico === `LEVAETRAZ`;
};

export const isTwoSolicitationService = (service) => {
  if (service.tipoServico === null || service.tipoServico === undefined) {
    throw new Error('Tipo serviço null ou undefined');
  }

  return service.tipoServico === `LEVAETRAZ` || service.tipoServico === 'SUBSOLO';
};

/** Serviços que exigem endereço de destino ao criar a solicitação. */
export const SERVICES_NEEDING_DESTINY = ['REBOQUE', 'SUBSOLO', 'LEVAETRAZ', 'TAXI'];

/**
 * Indica se o serviço exige endereço de destino.
 *
 * Diferente de `isTwoRouteService`/`isThreeRouteService`, recebe o código do serviço e
 * devolve `false` quando ele ainda não foi escolhido — é usado em telas onde o operador
 * seleciona o serviço depois de abrir o formulário.
 */
export const serviceNeedsDestiny = (tipoServico) =>
  SERVICES_NEEDING_DESTINY.includes(tipoServico);
